import React, { PropTypes, Component } from 'react';
import { Icon } from 'react-fast-ui';
import join from 'url-join';
import { Link } from 'react-router';

const ASTERISK = <span className="color-fastmodel-red"><Icon name="asterisk"/> </span>;

export default class TourneyName extends Component {
  static propTypes = {
    tourney: PropTypes.object.isRequired
  };

  render() {
    const { tourney: { id, name, custom } } = this.props;

    return (
      <span>
        {custom ? ASTERISK : null}
        <Link to={join('tourneys', id)}>{name}</Link>
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/TourneyName.jsx